(function() {
    'use strict';
    
a3_cabin_reports.controller('ItemPhotosCtrl', ItemPhotosCtrl);

    /**
    * @memberof CabinReports
    * @ngdoc controller
    * @name ItemPhotosCtrl
    * @description 
    *  Manages the Item Photos Modal View
    * @ngInject
    */
function ItemPhotosCtrl($scope, $uibModalInstance, PhotoFactory, item) {

		$scope.item = item;
		$scope.quality = 0.4;
        $scope.width = 1024;
        $scope.height = 768;
        $scope.comment = "Recommended for printed documents with smaller font";
		$scope.sizeLimitKb = 100;

		$scope.isImageTooLarge = isImageTooLarge;
        $scope.settingsSet = settingsSet;
   		$scope.settingsName = settingsName;
   		$scope.settingsText = settingsText;
        $scope.settings = 3;
        $scope.settingsMinus = settingsMinus;
        $scope.settingsPlus = settingsPlus;
        $scope.settingsDefault = settingsDefault;
    	$scope.imageChanged = imageChanged;
        $scope.imageError = imageError;
        $scope.rotateImageLeft = rotateImageLeft;
        $scope.rotateImageRight = rotateImageRight;
        $scope.cancel = cancel;
    	$scope.ok = ok;
		$scope.viewPhoto = viewPhoto;
		$scope.deletePhoto = deletePhoto;
    
        $scope.settingsText();
        
        /**
         * is Image Too Large 
         * @memberof ItemPhotosCtrl
         */
        function isImageTooLarge() {
			var b = false;
			var i = $scope.item;
			if (i != null && i.Photos != null && i.Photos.length > 0 && i.Photos[0].PhotoData != null) {
				b = (i.Photos[0].PhotoData.length > $scope.sizeLimitKb * 1024);
			}
			return b;
		}

        /**
         * Set settings
         * @memberof ItemPhotosCtrl
         */
        function settingsSet() {
			if ($scope.settings == 0) {
				$scope.width = 320;
				$scope.height = 240;
				$scope.comment = "Not recommended";
			} else if ($scope.settings == 1) {
				$scope.width = 640;
				$scope.height = 480;
				$scope.comment = "Recommended for objects/places";

			} else if ($scope.settings == 2) {
				$scope.width = 800;
				$scope.height = 600;
				$scope.comment = "Recommended for printed documents";
			} else if ($scope.settings == 3) {
				$scope.width = 1024;
				$scope.height = 768;
				$scope.comment = "Recommended for printed documents with smaller font";

			} else if ($scope.settings == 4) {
				$scope.width = 1280;
				$scope.height = 1024;
				$scope.comment = "Recommended for handwritten documents";
			}
		}

        /**
         * Show settings name
         * @memberof ItemPhotosCtrl
         */
        function settingsName() {
			if ($scope.settings == 0) return 'xsmall';
			else if ($scope.settings == 1) return 'small';
			else if ($scope.settings == 2) return 'normal';
			else if ($scope.settings == 3) return 'medium';
			else if ($scope.settings == 4) return 'high';
			else return 'High' + $scope.settings;
		}
     
        /**
         * Show settings text comment
         * @memberof ItemPhotosCtrl
         */
        function settingsText() {
			return $scope.comment + " (" + $scope.width + 'x' + $scope.height + ' ' + $scope.quality + ")";
		}
        
        /**
         * Lower image settings
         * @memberof ItemPhotosCtrl
         */
        function settingsMinus() {
			$scope.settings--;
			if ($scope.settings < 0) $scope.settings = 0;
			$scope.settingsSet();
		}
    
        /**
         * Higher image settings
         * @memberof ItemPhotosCtrl
         */
		function settingsPlus() {
			$scope.settings++;
			if ($scope.settings > 4) $scope.settings = 4;
			$scope.settingsSet();
		}
        
        /**
         * Set default image settings
         * @memberof ItemPhotosCtrl
         */
        function settingsDefault() {
			$scope.settings = 2;
			$scope.settingsSet();
		}

         /**
         * Change Image settings
         * @memberof ItemPhotosCtrl
         */
        function imageChanged(data) {
			//console.log('told of a new image', imageResult, this.imageBrowsed, $scope.imageBrowsed);
			var imageResult = data; //$scope.imageBrowsed;
			if (imageResult != null) {
				item.Photos = [];
				var img = PhotoFactory.createNew();
				img.PhotoData = imageResult.dataURL;
				img.FileType = imageResult.fileType || imageResult.file.type;
				item.Photos.push(img);
				$scope.filename = null;
			}
		}
      
        /**
         * Change Image settings
         * @memberof ItemPhotosCtrl
         */
        function imageError(err) {
			console.log('told of an error', err);
		}

        /**
         * Rotate Image to the Left
         * @memberof ItemPhotosCtrl
         */
        function rotateImageLeft(image) {

			var origImg = new Image();
			origImg.src = image.PhotoData;

			var oc = document.createElement('canvas');
			var octx = oc.getContext('2d');
			octx.mozImageSmoothingEnabled = false;
			octx.webkitImageSmoothingEnabled = false;

			// Inverse height and width as canvas size
			oc.width = origImg.height;
			oc.height = origImg.width;

			// Save original grid
			octx.save();
			// Set origin of canvas to center | 0,0 is now w/2 and h/2
			octx.translate(Math.floor(origImg.height / 2), Math.floor(origImg.width / 2));
			// Rotate the whole grid by X degrees
			octx.rotate((-1) * Math.PI / 2);
			// Draw the image into the rotated grid
			octx.drawImage(origImg, -Math.floor(origImg.width / 2), -Math.floor(origImg.height / 2), Math.floor(origImg.width), Math.floor(origImg.height));
			// Restore grid coordinates
			octx.restore();

			image.PhotoData = oc.toDataURL('image/jpeg', $scope.quality);
		}

        /**
         * Rotate Image to the Left
         * @memberof ItemPhotosCtrl
         */
        function rotateImageRight(image) {

			var origImg = new Image();
			origImg.src = image.PhotoData;

			var oc = document.createElement('canvas');
			var octx = oc.getContext('2d');
			octx.mozImageSmoothingEnabled = false;
			octx.webkitImageSmoothingEnabled = false;

			// Inverse height and width as canvas size
			oc.width = origImg.height;
			oc.height = origImg.width;

			// Save original grid
			octx.save();
			// Set origin of canvas to center | 0,0 is now w/2 and h/2
			octx.translate(Math.floor(origImg.height / 2), Math.floor(origImg.width / 2));
			// Rotate the whole grid by X degrees
			octx.rotate(Math.PI / 2);
			// Draw the image into the rotated grid
			octx.drawImage(origImg, -Math.floor(origImg.width / 2), -Math.floor(origImg.height / 2), Math.floor(origImg.width), Math.floor(origImg.height));
			// Restore grid coordinates
			octx.restore();

			image.PhotoData = oc.toDataURL(image.FileType, $scope.quality);
		}

        /**
         * Close Modal
         * @memberof BarTrolleyCtrl
         */
        function ok() {
			$uibModalInstance.close();
		}

        /**
         * Close Modal
         * @memberof BarTrolleyCtrl
         */
        function cancel() {
			$uibModalInstance.close();
		}

        /**
         * View  photo in new window
         * @memberof ItemPhotosCtrl
         */
        function viewPhoto(pho) {
			window.open(pho.PhotoData);
		}
 
        /**
         * Delete photo
         * @memberof ItemPhotosCtrl
         */
        function deletePhoto(pho) {
			bootbox.dialog({
				message: "Are you sure you want to delete this photo?",
				title: "<strong>Delete record<strong>",
				buttons: {
					no: {
						label: "No",
						className: "btn-default",
						callback: function() {}
					},
					yes: {
						label: "Yes",
						className: "btn-warning",
						callback: function() {
							PhotoFactory.deleteFromList(pho, item.Photos);
							$scope.$apply();
						}
					}
				}
			});
		}

	}
    
})();